import React from 'react';

const IlosUploadButton = ({ token }) => (
  <iframe
    title="Video uploader"
    src={`https://app.ilosvideos.com/embed/api/uploader/${token}?uploaderType=basic`}
    allowTransparency="true"
    scrolling="no"
    style={{
      width: '120px',
      height: '31px',
      overflow: 'hidden',
      backgroundColor: 'transparent',
      marginLeft: 'auto',
      marginRight: 'auto',
    }}
    frameBorder="0"
  />
);

export default IlosUploadButton;
